import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-notification-details',
  templateUrl: './edit-notification-details.component.html',
  styleUrls: ['./edit-notification-details.component.scss']
})
export class EditNotificationDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
